import { NotificationSubTemplateResponseModel } from "./self-scheduling-config-model/notification-subtemplate-response-model";

export class SettingsNotificationResponseModel {
  appNotificationId: number;
  appModuleId: number;
  appNotificationEventName: string;
  appNotificationInApp: Boolean;
  appNotificationInSms: Boolean;
  appNotificationInEmail: Boolean;
  appNotificationInVoicemail: Boolean;
  appModuleDisplayFeatureName: string;
  isActive: Boolean;
  modifiedByUserInfoId: number;
  dateTimeCreated: Date;
  dateTimeLastModified: Date;
  appNotificationGroupEventName: string;
  appNotificationTemplateName: string;
  appNotificationGroupEventOrder: number;
  appNotificationTemplateOrder: number;
  notificationTemplate: Array<NotificationTemplateModel>;
  notificationSubTemplate: Array<NotificationSubTemplateModel>;

}

export class NotificationTemplateModel {
  appNotificationTemplateId: number;
  appNotificationId: number;
  appRoleId: number;
  appEnumnotificationType: string;
  appNotificationTemplateFormat: string;
  appNotificationTemplateSubject: string;
  isActive: Boolean;
  modifiedByUserInfoId: number;
  dateTimeCreated: Date;
  dateTimeLastModified: Date;
}

export class NotificationSubTemplateModel {
  id:number;
  appNotificationId :number;
  appNotificationEventName? :string;
  appNotificationEmailTemplateFormat?:string;
  appNotificationSMSTemplateFormat?:string;
  appNotificationTemplateSubject?:string;
  appNotificationInSms:boolean;
  appNotificationInEmail:boolean;
  isEmailChecked:boolean;
  isSMSChecked:boolean;
  isActive:boolean;
  createdByUserInfoId:number;
  modifiedByUserInfoId:number;
  dateTimeCreated:Date;
  dateTimeLastModified :Date;
}


export class SettingsGroupNotificationListResponseModel {
  appModuleId: number;
  appNotificationEventName: string;
  appModuleDisplayFeatureName: string;
  notificationTemplateList: SettingsNotificationResponseModel[];
  isGroupCollapse: Boolean;
  isEmailSelectAllCheck: boolean;
  isSMSSelectAllCheck: boolean;
}
